export const AMORTIZATION_SCHEDULE_OPENED = 'true';
